export default __webpack_public_path__ + "static/media/contact.c4532a40.pdf";